import * as S from './style';
import * as T from '../../../../../components/Typography';

const Letter1 = () => {
  return (
    <S.Wrapper>
      <T.P ta="right" fontFamily="garamond">
        Lowtown Hospital
      </T.P>
      <T.P ta="right" fontFamily="garamond">
        Lowtown
      </T.P>
      <T.P ta="right" fontFamily="garamond">
        FR1 0RF
      </T.P>
      <T.P ta="right" fontFamily="garamond" mb="4">
        <T.P weight="bold" fontFamily="garamond" style={{ display: 'inline' }}>
          NHS Patient Number:
        </T.P>{' '}
        ZZZZZ33330{' '}
      </T.P>
      <T.P weight="bold" fontFamily="garamond">
        Private and confidential
      </T.P>
      <T.P mb="4" fontFamily="garamond">
        12 May 2015
      </T.P>
      <T.P weight="bold" mb="4" fontFamily="garamond">
        Dear Mr Smith
      </T.P>
      <T.P mb="4" fontFamily="garamond">
        An appointment has been made for you to attend the outpatient clinic for
        a review of your condition on:
      </T.P>
      <T.P weight="bold" mb="4" fontFamily="garamond">
        Thursday 2nd July 2015 at 10.15 am. with Mr Hajek in the Ear, Nose and
        Throat Department.
      </T.P>

      <T.P fontFamily="garamond" mb="4">
        Please bring this letter with you and report to the reception desk in
        the{' '}
        <T.P weight="bold" style={{ display: 'inline' }}>
          Main Outpatients Department.
        </T.P>{' '}
        Please bring with you a list of all your current medication.
      </T.P>
      <T.P mb="4" fontFamily="garamond">
        If you are unable to attend at this time or if you would like to change
        your appointment, please telephone the appointments line on: 0500 050505
        as soon as possible. You can also contact us through the CHOOSE AND BOOK
        service online{' '}
        <S.Link
          href="https://www.chooseandbook.nhs.uk"
          target="_blank"
          rel="noreferrer"
        >
          www.chooseandbook.nhs.uk
        </S.Link>
      </T.P>
      <T.P mb="4" fontFamily="garamond">
        Failure to attend this appointment without prior notification may result
        in your being removed from our waiting list.
      </T.P>
      <T.P fontFamily="garamond">Yours sincerely</T.P>
      <T.P mb="4" fontFamily="garamond">
        Booking Clerk
      </T.P>
    </S.Wrapper>
  );
};

export default Letter1;
